<script>
    import CaseStudy from "./CaseStudy.svelte";

    let title = "VuL Inc";
    let headerLine =
        "Like Uber Eats...But For Car Gasoline";
    let tagLine = "";
    let productUrl = "https://vul.services";
    let headerImage = {
        src: "/images/VULIOS1.png",
        width: 512,
        height: 512
    };
</script>

<style>
    ul {
        display: inline-block;
        text-align: left;
    }
    .list {
        text-align: center;
    }
    .page-header {
        height: 20vh !important;
    }
</style>

<svelte:head>
    <title>{title} Case Study - VuL</title>
</svelte:head>

<div
        class="page-header header-filter blue-filter"
        data-parallax="true"
        style="background-image: url('/assets/img/web.jpg')" />
<div class="container">
    <div class="section text-center">
        <div class="card card-body">
            <h1>{title}</h1>
            <h2>{headerLine}</h2>
            <div>
                <a href="https://apps.apple.com/us/app/vul/id1516944405">
                    <img
                            src="/images/vulios.png"
                            alt="iOS sign in screen"
                            height="360px" />
                </a>

                <img src="/images/vultruck.jpg"
                     style="border-radius: 5%"
                     height="360px" width="360px"alt="GMGT employees during a show" />
                <i>{tagLine}</i>
            </div>
            <div>
                <h5>
                    Based out of Spartanburg, SC
                    <b>VuL</b>
                    is a premier example of pandemic innovation. Contactless gas deliveries done quickly, safely and promptly.
                </h5>

                <h5>
                    But delivering things is hard. First, you need to establish a service area, you don't want to serve
                    an area too big, otherwise you compromise your ability to deliver your products fast. You also need
                    consistent and prompt notification - your customers need to know when you're on the way. Finally, you need
                    to support a dynamic pricing model, the app needs to be smart enough to charge your customers fairly
                    for you driving an unknown amount of miles to them. Enter Code World Solutions.
                </h5>
                <br/>
                <img
                        src="/images/vulicon.png"
                        alt="co-working space"
                        style="border-radius: 50%"
                        height="360px" />
                <div />
                <h5>
                    Utilizing Geo-fencing (the process of drawing virtual zones on maps) we were able to create clear and concise areas
                    for VuL's customers. More importantly we were able to create an algorithm that fairly compensates VuL
                    drivers for distances they travel to each customer. We do this by providing an algorithm that dynamically
                    scales based on traffic, distance, and proximity to VuL hotspots. But delivery is one part - how do you charge
                    your customers? We built a custom payment terminal for VuL's customers, our payment processor uses is secure, and easy to use
                    while also protecting against things like double charges and identity fraud. Code World, while leveraging trusted technologies like Google Maps,
                    delivering high quality fuel at affordable prices becomes nearly trivial.
                </h5>

                <h2>But Innovation Doesn't Stop There...</h2>

                <p>
                    We're partnering with VuL to present a brand new experience, App Clips. VuL customers will soon be
                    able to enjoy VuL delivery services without even having to download an app. Because being an innovation partner is about
                    more then just delivering on tech request. It's about pushing your business and the industry as whole further.
                </p>

                <a href="https://vulinc.com">
                    <p>Download the Android or iPhone app at VuLInc.com</p>
                </a>


                <img
                        src="/images/vulapp.png"
                        alt="co-working space"
                        height="360px" />
                <div />
                <h4>Stop Pumping and Get Going</h4>
                <img
                        src="/images/vulcar.jpg"
                        alt="co-working space"
                        width="488px"
                        height="360px" />
                <div />

                <h5 class="info-title">The CWS competitive advantage</h5>

                <div class="list">
                    <ul class="list-group">
                        <li class="list-group-item">
                            Great native apps that utilize the best aspects of smartphones.
                        </li>
                        <li class="list-group-item">
                            Great user experiences on multiple devices.
                        </li>
                        <li class="list-group-item">Integrations with powerful services like Google Maps.</li>
                        <li class="list-group-item">
                            Smart algorithms that support and improve your business model.
                        </li>
                    </ul>
                </div>

                <div>
                    <i class="material-icons">group_work</i>
                    <h5>
                        As a result of working with Code World Solutions, VuL has been able to delight their customers
                        and focus on their mission. Making sure everyone "Dumps The Pump Now"
                    </h5>
                </div>

            </div>
            <div class="progress">
                <div
                        class="progress-bar bg-danger"
                        role="progressbar"
                        style="width: 100%"
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100" />
            </div>
            <div>
                <div>
                    <h4 class="info-title">Collaborate</h4>
                    <h5>
                        Working with CWS provides you access to a world class development
                        team without the cost of maintaining your own. The team is available
                        when you're ready.
                    </h5>
                    <h4>Interested?</h4>
                    <a href="/contact">Contact us.</a>
                </div>
            </div>
        </div>
    </div>
</div>
